import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult, PageStyle } from '@ftr/foundation'
import { MfaRequirementData, MultifactorAuthenticationService } from '../../services'

@Component({
  selector: 'ftr-mfa-requirement',
  templateUrl: './mfa-requirement.component.html',
  providers: [MultifactorAuthenticationService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MfaRequirementComponent implements OnInit {
  @Input() courtSystemId!: Uuid
  mfaRequirementFormData$: ApiResult<MfaRequirementData>

  readonly pageStyleNarrow = PageStyle.Narrow

  constructor(private multifactorAuthenticationService: MultifactorAuthenticationService) {}

  ngOnInit(): void {
    this.mfaRequirementFormData$ = this.multifactorAuthenticationService.getRequirementConfiguration(this.courtSystemId)
  }

  retry(): ApiResult<MfaRequirementData> {
    return this.multifactorAuthenticationService.getRequirementConfiguration(this.courtSystemId)
  }
}
